import {
  DEFAULT_EXECER
} from '@/config/contants.js'
const getters = {
  // 是否平行链
  isParallelChain: state => {
    // 当前的节点配置为平行链，或者代码打包的配置为平行链
    return state.apiSetting.execer !== DEFAULT_EXECER
  },
  // 主代币symbol
  baseCoin: () => {
    return process.env.VUE_APP_DEFAULT_COIN || 'BTY'
  }
};

export default getters;